// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__35wj6","rootCenter":"LoadMoreObserver_rootCenter__xlAU_","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__yhfHH"};